import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const createSupplier = async (payload) => {
  return await axiosInstance.post("supplier/supplier-master", payload, { headers });
};

export const fetchSupplier = async () => {
  return await axiosInstance.get("supplier/supplier-master", { headers });
};



export const deleteSupplier = async (groupId) => {
  return await axiosInstance.delete(`supplier/supplier-master/${groupId}`, { headers });
};

export const updateSupplier = async (payload) => {
  return await axiosInstance.put("supplier/supplier-master", payload, { headers });
};

export const fetchSupplierbyId = async (id) => {
  const response = await axiosInstance.get(`supplier/supplier-master/${id}`, {
    headers,
  });
  return response.data;
};
